import Backdraft from "backdraft-app/src/backdraft";
import _ from "underscore";

Backdraft.app("Shared/SignalExpression", function(app) {
  app.model("ConjunctionTerminal", "ExpressionTerminal", {
    defaults: {
      terminal: 'and'
    },

    initialize: function() {
      this.listenTo(this, 'change:terminal', function() { this.trigger('validate'); });
    },

    beforeSet: function(attributes) {
      if (attributes.terminal === '&&') {
        attributes = _.extend({}, attributes, { terminal: 'and' });
      } else if (attributes.terminal === '||') {
        attributes = _.extend({}, attributes, { terminal: 'or' });
      }

      return attributes;
    },

    type: function() {
      return 'Conjunction';
    },

    isConjunctionTerminal: function() {
      return true;
    }
  });
});
